import { useEffect, useRef, useState, useTransition } from "react";
import { WalletIcon } from "../../../assets/fonts/icon/icons";
import { commaDigits, complexDigitToman, convertPersian, isEmpty, validateInput } from "../../../tools/tools";

import styles from "./wallet.module.scss";
import { Row, Col, Form, Radio, Input, Button } from "antd";
import ReactInputMask from "react-input-mask";
import Layouts from "../../layout/layouts";
import InCreaseWallet from "../../../components/increaseWallet/InCreaseWallet";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Loading from "../../../components/loader/loading";
const Wallet = () => {
  const [t] = useTransition("global");
  const [searchParam] = useSearchParams();

  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });

  const [openIncress, setOpenIncress] = useState(false);
  const [localInvoiceId, setLocalInvoiceId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const bankRef = useRef("");

  useEffect(() => {
    if (!isEmpty(searchParam.get("localInvoiceId"))) {
      const getLocalInvoiceID = searchParam.get("localInvoiceId");
      setLocalInvoiceId(getLocalInvoiceID);
      setOpenIncress(true);
    }
  }, []);

  const handleCallBackCharge = (value) => {
    setIsLoading(true);
    if (value?.length > 0) {
      bankRef.current.innerHTML = value;
      document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
    } else {
      setLocalInvoiceId("");
      setOpenIncress(false);
    }
    setIsLoading(false);
  };

  return (
    <>
      <div className={styles.wallet_container}>
        <div className={styles.holder_wallet_box}>
          <Row gutter={30}>
            <Col xxl={8} xl={8} lg={12} md={12} sm={12} xs={24}>
              <div className={`${styles.box_wallet}  ${styles.wallet_color}`}>
                <div className={styles.title_wallet}>
                  <WalletIcon />
                  کل اعتبار
                </div>
                <div className={styles.content_wallet}>
                  <h3>
                    <span>{complexDigitToman(_currentUser?.walletAmount)}</span>تومان
                  </h3>
                </div>
                <div className={styles.increase}>
                  <div className="holder-button">
                    <Button onClick={() => setOpenIncress(true)} className={styles.btnCharge}>
                      افزایش اعتبار
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
            <Col xxl={8} xl={8} lg={12} md={12} sm={12} xs={24}>
              <div className={`${styles.box_wallet} `}>
                <div className={styles.title_wallet}>قابل برداشت</div>
                <div className={styles.content_wallet}>
                  <h3>
                    <span>{complexDigitToman(_currentUser?.walletAmount - _currentUser?.freezeWalletAmount)}</span>تومان
                  </h3>
                </div>
              </div>
            </Col>
            <Col xxl={8} xl={8} lg={12} md={12} sm={12} xs={24}>
              <div className={`${styles.box_wallet} `}>
                <div className={styles.title_wallet}>ودیعه</div>
                <div className={styles.content_wallet}>
                  <h3>
                    <span>{complexDigitToman(_currentUser?.freezeWalletAmount)}</span>تومان
                  </h3>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <InCreaseWallet
        open={openIncress}
        planid={process.env.REACT_APP_INCREASE_ACCOUNT}
        msisdn={_currentUser?.telnoone}
        localInvoiceId={localInvoiceId}
        price={0}
        callback={handleCallBackCharge}
        activePrice={true}
      />
      <div ref={bankRef}></div>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default Wallet;
